'use client'

import { useSearchParams } from 'next/navigation'
import { type FC, type PropsWithChildren } from 'react'
import { Configure } from 'react-instantsearch'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import { useSearchClient } from '../../../../algolia'
import { useDeviceDetectorContext } from '../../../../device-detector'
import {
  PRODUCT_SEARCH_HITS_PER_PAGE,
  ProductSearchVirtualWidgetSearchBox,
  useProductSearchAlgoliaRouting,
  useProductSearchContext,
} from '../../../../product-search'

export const StoryblokBrandAlgoliaSearch: FC<
  PropsWithChildren<{ filters?: string }>
> = ({ children, filters }) => {
  const searchParams = useSearchParams()

  const {
    productSearchConfig: { baseAlgoliaConfig },
  } = useProductSearchContext()
  const searchClient = useSearchClient()
  const { deviceType } = useDeviceDetectorContext()

  const { productsAlgoliaIndex } = baseAlgoliaConfig

  return (
    <InstantSearchNext
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      indexName={productsAlgoliaIndex}
      routing={useProductSearchAlgoliaRouting()}
      searchClient={searchClient}
    >
      <Configure
        analytics={false}
        analyticsTags={['results', 'externe', deviceType]}
        clickAnalytics
        facetingAfterDistinct
        filters={filters}
        getRankingInfo
        hitsPerPage={PRODUCT_SEARCH_HITS_PER_PAGE}
        userToken={searchParams.get('userToken') ?? undefined}
      />
      {children}
      {/*
      The search box is not part of the current page, it's located in the header.
      This virtual widget is used to preserve search parameters in the URL for routing.
      */}
      <ProductSearchVirtualWidgetSearchBox />
    </InstantSearchNext>
  )
}
